<div class='border' [ngClass]='{ active: active }'>
  <div class='wrapper number'>
    <span class='number'>{{ num }}.</span>
  </div>

  <div class='wrapper title'>
    <span class='title'>{{ title }}</span>
  </div>

  @if (validated) {
    <div class='wrapper icon'>
      <ml-icon iconName="check2"></ml-icon>
    </div>
  }
</div>
